module.exports = __webpack_public_path__ + "img/28.5a0b9ca6.jpg";